import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/theme';
import { API_ENDPOINTS } from '../config.js';

export default function ForgotPassword() {
  const { t, i18n } = useTranslation();
  const { isDark } = useTheme();
  const colors = getThemeColors(isDark);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!email) {
      setError(t('forgotPassword.enterEmail'));
      return;
    }
    
    setError('');
    setSuccess('');
    setLoading(true);
    
    try {
      const res = await fetch(API_ENDPOINTS.FORGOT_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': i18n.language || 'en',
        },
        credentials: 'include',
        body: JSON.stringify({ email }),
      });
      
      const data = await res.json();
      
      if (!res.ok) {
        // Backend error is already translated
        setError(data.error || t('forgotPassword.error'));
        setSuccess('');
      } else {
        // Backend message is already translated by the backend
        setSuccess(data.message || t('forgotPassword.resetLinkSent'));
        setError('');
        // Clear email field on success
        setEmail('');
      }
    } catch (err) {
      setError(t('auth.serverError'));
      setSuccess('');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 10px',
    margin: '6px 0 18px 0',
    borderRadius: 6,
    border: `1px solid ${colors.border}`,
    fontSize: 16,
    background: colors.backgroundHover,
    color: colors.text,
    outline: 'none',
    transition: 'border-color 0.2s, background-color 0.2s, color 0.2s',
  };

  return (
    <div style={{minHeight: '100vh', background: colors.backgroundLight, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background-color 0.3s ease'}}>
      <form onSubmit={handleSubmit} style={{background: colors.card, borderRadius: 16, boxShadow: `0 4px 24px ${colors.shadowHover}`, padding: 36, width: '100%', maxWidth: 400, transition: 'background-color 0.3s ease, box-shadow 0.3s ease'}}>
        <h2 style={{fontSize: 24, fontWeight: 800, color: colors.primary, marginBottom: 24}}>{t('forgotPassword.title')}</h2>
        <p style={{color: colors.textSecondary, marginBottom: 24, fontSize: 14}}>{t('forgotPassword.enterEmail')}</p>
        {error && <div style={{color: colors.error, marginBottom: 12}}>{error}</div>}
        {success && <div style={{color: colors.success, marginBottom: 12}}>{success}</div>}
        <label style={{fontWeight: 600, color: colors.text}}>{t('forgotPassword.email')}</label>
        <input type="email" value={email} onChange={e => { setEmail(e.target.value); setError(''); setSuccess(''); }} style={inputStyle} autoComplete="email" required />
        <button type="submit" disabled={loading} style={{marginTop: 18, width: '100%', background: loading ? colors.textLight : colors.primary, color: 'white', fontWeight: 700, fontSize: 18, borderRadius: 8, padding: '14px 0', border: 'none', boxShadow: `0 2px 8px ${colors.shadow}`, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, transition: 'background-color 0.2s'}} onMouseEnter={(e) => !loading && (e.target.style.background = colors.primaryHover)} onMouseLeave={(e) => !loading && (e.target.style.background = colors.primary)}>{loading ? t('common.loading') || 'Loading...' : t('forgotPassword.sendResetLink')}</button>
      </form>
    </div>
  );
} 